module.exports = __webpack_public_path__ + "static/media/pioricost-slogan.9f2912ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pioricost-slogan.png
// module id = 142
// module chunks = 0